import { render, staticRenderFns } from "./ThemeTemplate.vue?vue&type=template&id=1d5e22f2&scoped=true&"
import script from "./ThemeTemplate.vue?vue&type=script&lang=js&"
export * from "./ThemeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ThemeTemplate.vue?vue&type=style&index=0&id=1d5e22f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e22f2",
  null
  
)

export default component.exports